// api.js
import axios from "axios";
import apilink from "./APIlink";

// Instancia base de Axios
const api = axios.create({
  baseURL: apilink,
  headers: {
    "Content-Type": "application/json",
    Authorization: `JWT ${localStorage.getItem("access")}`,
  },
});

// Cola de promesas inicializada
let requestQueue = Promise.resolve();


// Interceptor de request: solo ajusta config, no ejecuta
api.interceptors.request.use(
  (config) => {
    // Aquí puedes modificar headers dinámicamente si lo necesitas
    const token = localStorage.getItem("access");
    if (token) {
      config.headers.Authorization = `JWT ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de response: manejo defensivo de errores
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.data) {
      const data = error.response.data;
      console.error("[API ERROR DATA]", data);
    } else {
      console.error("[API ERROR]", error.message);
    }
    return Promise.reject(error);
  }
);

function queuedApiList(config) {
  requestQueue = requestQueue.then(async () => {
    if (!config?.method){
      config.method = "get"
    }
    try {
      const response = await api.request(config);
      return response;
    } catch (err) {
      console.error("[QUEUE api_list] Error en:", config.url, err.message);
      throw err;
    }
  });

  return requestQueue;
}


export default queuedApiList;